import { CsnpQualifierType } from '~/generated/api-clients-generated'

// Quoting labeled cardiovascular plans ObstructivePulmonary before CardiovascularDisorders existed,
// so quotes and applications started before the fix still carry it. On a plan it only ever meant
// cardiovascular
export function normalizePlanCsnpQualifiers(
  qualifiers?: CsnpQualifierType[] | null
): CsnpQualifierType[] {
  return _uniq(
    (qualifiers ?? []).map((q) =>
      q === CsnpQualifierType.ObstructivePulmonary ? CsnpQualifierType.CardiovascularDisorders : q
    )
  )
}

// The csnp_qualifiers application ext stores names, e.g. ["Diabetes"], so px and oxcart read the same value
export function csnpQualifiersFromNames(names: string[]): CsnpQualifierType[] {
  return normalizePlanCsnpQualifiers(
    names
      .map((n) => CsnpQualifierType[n as keyof typeof CsnpQualifierType])
      .filter((q) => !_isNil(q))
  )
}

export function csnpQualifiersToNames(qualifiers?: CsnpQualifierType[] | null): string[] {
  return normalizePlanCsnpQualifiers(qualifiers).map((q) => CsnpQualifierType[q])
}
